<script lang="ts">
    import { t } from "@lernetz/svelte-translate";
    import { resolve } from "./resolve";
    import { Icon } from "@lernetz/svelte-icon";
    import { setupSharedProps, sharedProps } from "../../setup";
    import kianaSvgRaw from '../../icons/kiana.svg?raw';
    import flintSvgRaw from '../../icons/flint.svg?raw';

    const kianaSvg = kianaSvgRaw
        .replace(/cls-/g, 'kiana-cls-')
        .replace('<svg ', '<svg style="height:100%;width:auto;" ');
    const flintSvg = flintSvgRaw
        .replace(/cls-/g, 'flint-cls-')
        .replace('<svg ', '<svg style="height:100%;width:auto;" ');


    export let dashboard;
    export let type = 'prior';
    export let mode = 'single';
    export let pupils = 0;

    setupSharedProps();

    let questionNr = 0;
    let questions;
    let last = false;
    let right = 0;
    let wrong = 0;
    let result = 0;

    if(type == 'prior') {
        questions = dashboard.prior_questions;
    }
    else {
        questions = dashboard.after_questions;
    }

    function next() {
        if(questionNr < questions.length) {
            questionNr ++;
        }
        if(questionNr == questions.length) {
            last = true;
        }
    }

    function updateResults(results) {
        right = right + results.detail.right;
        wrong = wrong + results.detail.wrong;
        result = Math.round(right / ( right + wrong) * 100)
    }
</script>
<div class="{dashboard.cycle == 'cycle1' ? 'bg-yellow-light' : 'bg-green-light'} w-full min-h-screen flex items-center flex-col px-16 md:px-24 pt-112 md:pt-128 pb-48">
    <Icon name="{sharedProps.currentLocale == 'de' ? 'logo-element-hero' : 'logo-element-hero-fr'}" class="w-96 md:w-128 xl:w-160 absolute right-12 top-8 md:right-24 md:top-12"></Icon>
    {#if last}
        <div class="relative w-full max-w-[600px]">
            <!-- Figuren-Offsets sind auf die aktuelle Kartengrösse abgestimmt; bei Text-/Layoutänderungen (v.a. FR) Position visuell prüfen -->
            <div class="h-[240px] md:h-384 absolute -left-[15px] md:-left-[60px] xl:-left-[100px] bottom-[-30px] md:bottom-auto md:top-[200px] block z-10">{@html kianaSvg}</div>
            <div class="h-[240px] md:h-384 absolute -right-[15px] md:-right-[60px] xl:-right-[100px] bottom-[-30px] md:bottom-auto md:top-[200px] block z-10 -scale-x-100">{@html flintSvg}</div>
            <div class="bg-white text-center py-24 px-24 md:py-32 md:px-56 rounded-3xl flex flex-col items-center relative pb-[260px] md:pb-32 md:min-h-[520px]">
            <div class="font-Caveat text-54 md:text-80 text-blue-main">{$t('done')}</div>
            <div class="mt-24 text-18">{$t('You have answered all the questions, well done!')}</div>
            <div class="bg-blue-light px-32 py-16 h-160 rounded-3xl w-fit justify-center items-center content-center mt-32">
                <div class="text-54 font-bold">{result}%</div>
                <div class="text-16">{$t('of the answers correct')}</div>
            </div>
            {#if mode == "class"}
            <a href="/dashboard/{dashboard.id}">
                <button class="bg-blue-main p-8 rounded-md h-fit flex gap-12 py-10 px-24 mt-48 md:mt-96">
                    <div class="text-white text-18 font-bold">{$t('to overview')}</div>
                    <Icon name="arrow-right" class="w-28 h-28 place-self-center"></Icon>
                </button>
            </a>
            {/if}
        </div>
        </div>
    {:else}
        {#if (type == "prior" && !dashboard.lockPrior) || (type == "after" && !dashboard.lockAfter)}
            {#key questionNr}
                <svelte:component
                    this={resolve(questions[questionNr])}
                    question={questions[questionNr]}
                    dashboard={dashboard}
                    type={type}
                    {questionNr}
                    {mode}
                    {last}
                    on:next={next}
                    on:updateResults={updateResults}
                />
            {/key}
        {:else}
            <div>{$t('test is locked')}</div>
        {/if}
    {/if}
</div>
